import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Sidebar from "./components/Sidebar";
import "./MediaQuery.css";
// import Accordion from "./pages/Accordion.js";
// import TermsJune from "./pages/TermsJune_19.jsx";
import TermsCokeFoodLoot from "./pages/TermsCokeFoodLoot.jsx";

const App = () => {
  return (
    // <div className='wrapper'>
    //             <Accordion />
    //           </div>

    <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <div className="App">
        {/* <Sidebar> */}
        <Routes>
          <Route
            index
            path="/coke-foodloot/McD/tandc"
            element={<TermsCokeFoodLoot />}
          />
          {/* <Route path="/coke-foodloot/McD/faqs" element={<Accordion />} /> */}
        </Routes>
        {/* </Sidebar> */}
      </div>
    </BrowserRouter>
  );
};

export default App;
